
//7
Object.defineProperty(exports, "__esModule", { value: true });
require("../input-with-options/InputWithOptions.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "AddressInput1270185607",
    {"root":"AddressInput1270185607--root","option":"AddressInput1270185607--option","iconWrapper":"AddressInput1270185607--iconWrapper","icon":"AddressInput1270185607--icon","optionContent":"AddressInput1270185607--optionContent"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/address-input/AddressInput.st.css
// module id = 1306
// module chunks = 0